"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
var dompurify_1 = __importDefault(require("dompurify"));
var Box_1 = require("./Box");
var react_2 = require("@emotion/react");
var StyledText = (0, Box_1.createBasicComponent)(function (props) { return ({
    fontSize: '16px',
    fontWeight: 'normal',
    letterSpacing: 'normal',
    lineHeight: 'normal',
    fontFamily: props.theme.fonts.Roboto,
}); });
StyledText.displayName = 'Text';
function Text(props) {
    var children = props.children;
    if (typeof children === 'string' && children.startsWith('html:')) {
        return (react_1.default.createElement(CleanedText, __assign({}, props)));
    }
    return (react_1.default.createElement(StyledText, __assign({}, props)));
}
exports.default = Text;
function CleanedText(props) {
    var children = props.children, rest = __rest(props, ["children"]);
    var allowHtmlText = (0, react_2.useTheme)().allowHtmlText;
    // eslint-disable-next-line
    var memoizedHtml = (0, react_1.useMemo)(function () { return dompurify_1.default.sanitize(children.replace(/^html:/, '')); }, [children]);
    if (!allowHtmlText) {
        return (react_1.default.createElement(StyledText, __assign({}, props)));
    }
    return (react_1.default.createElement(StyledText, __assign({}, rest, { dangerouslySetInnerHTML: {
            __html: memoizedHtml
        } })));
}
